import { Form } from '@kanda-libs/ks-component-ts';

import APRs from './components/APRs';
import Deposit from './components/Deposit';
import RepaymentInfo from './components/RepaymentInfo';
import Terms from './components/Terms';
import { useFinanceFormContext } from './context';

const FinanceFormContent: React.FunctionComponent = function () {
  const { form, onSubmit } = useFinanceFormContext();
  return (
    <>
      <h2 className="text-16-24-b md:text-20-24-b mb-2">Customise your plan</h2>
      <h3 className="text-12-18 md:text-14-22 text-neutral-700 mb-4">
        Adjust the options below to suit your budget
      </h3>
      <Form
        form={form}
        id="checkout-finance-form"
        onSubmit={onSubmit}
        className="flex flex-col"
      >
        <APRs />
        <Terms />
        <Deposit />
        <RepaymentInfo />
      </Form>
    </>
  );
};

export default FinanceFormContent;
